/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const ComputeOrder = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ComputeOrder = ClosedEnum<typeof ComputeOrder>;

/** @internal */
export const ComputeOrder$inboundSchema: z.ZodNativeEnum<typeof ComputeOrder> =
  z.nativeEnum(ComputeOrder);
/** @internal */
export const ComputeOrder$outboundSchema: z.ZodNativeEnum<typeof ComputeOrder> =
  ComputeOrder$inboundSchema;
